import BigNumber from "bignumber.js";

import { round, HALF_DOWN } from "./helpers/RoundingHelpers";

const canBeConvertedToMoney = amount =>
    (amount || amount === 0) && (typeof amount === "number" || typeof amount === "string");

export function convertToMoney(amount, nbDecimals = 2) {
    if (!canBeConvertedToMoney(amount)) return amount;

    return round(amount, nbDecimals, HALF_DOWN).toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: Math.min(2, nbDecimals),
        maximumFractionDigits: Math.max(2, nbDecimals)
    });
}

export function convertToFractionalMonetaryUnits(amount) {
    if (!canBeConvertedToMoney(amount)) return amount;
    const hundred = 100;

    return new BigNumber(amount)
        .multipliedBy(hundred)
        .integerValue(BigNumber.ROUND_HALF_DOWN)
        .toNumber();
}
